import React, { useState, useContext, useEffect } from "react";
import { useLocation } from "react-router-dom";

import MonthPickerComponent from "../Utils/MonthPickerComponent";
import xls from "../images/xls/png/Group 47.png";
// import ExcelPopup from "../Components/ExcelPopup";
import line from "../images/line.png";
import moment from "moment";
import FileIcon from "../images/file.png";
import FileIconBlur from "../images/fileblur.png";
import Card from "../Components/ListPageCard/Card";
import Layout from "../Components/Layout";
import MainMenu from "../Components/MainMenu";
import Table from "../Components/AllTableComponent";
import FilterTag from "../Components/Tag";
import RefineSearch from "../Components/RefineSearchComponent";
// import chatPopupIcon from "../images/chatPopupIcon.png";
// import ChatPopup from "../Components/ChatPopup";
import "../index.css";
import SavedFilterContent from "../Components/SavedFilter";
import ExportPopup from "../Components/ExportPopup";
import { data } from "../Components/ExportPopup/ExportData";
import { exportPDF } from "../Config/config";
import InvestmentRefineSearch from "../Components/RefineSearch/InvestmentRefineSearch";
import Constants from "../Constants";
import { PeFilterContext } from "../Contexts/PeFilterContext";
// import Flatpickr from "react-flatpickr";
import "flatpickr/dist/flatpickr.css";
// import MonthRangePicker from "../Components/shared/MonthRangePicker";
import { UserContext } from "../Contexts/UserContext";
import DirectoryDownloadAccess, {
  ExportDirectoryExcel,
} from "../Components/ExportPopup/DirectoryExport";
import { Switch, Tooltip } from "antd";
import ConfirmPopup from "../Utils/ConfirmPopup";
import ExcelDownloader from "../Components/shared/ExcelDownloader";
import { TableDataContext } from "../Contexts/TableDataContext";
import ToggleDealsViewButton from "../Components/ToggleDealsView";
import { FaFilter } from "react-icons/fa";
import { IoClose  } from "react-icons/io5";
import { RiMailDownloadLine } from "react-icons/ri";
import DownloadTrigger from "../Components/ExportPopup/DownloadTrigger";

// import Echo from 'laravel-echo';
// import Pusher from 'pusher-js';
// import { notification } from "antd";

// import echo  from '../../src/Components/NotificationSettings/echo';

/**
 * The Home function is a JavaScript function that renders a page layout with a top navigation bar, a
 * main content area with a filter tag and a table, and a sidebar with refine search options.
 * @returns The Home component is being returned.
 */
function Home() {
  const location = useLocation();
  
  // const [showModal, setShowModal] = React.useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [showDownload, setShowDownload] = useState(false);
  const [date, setDate] = useState([
    moment().startOf("month").subtract(12, "months").format("YYYY-MM-DD"),
    moment().endOf("month").format("YYYY-MM-DD"),
  ]);
  useEffect(()=>{
    if (window.innerWidth < 800) {
        // setOpen(true);
        setIsMobile(true);
    }    },[])
  const { refineSearchFilters: contextRefineSearchFilters , setRefineSearchFilters: contextSetRefineSearchFilters ,isMobile,setOpen,open,setIsMobile} = useContext(PeFilterContext);
  const [refineSearchFilters, setRefineSearchFilters] = useState(contextRefineSearchFilters || {});
  console.log(refineSearchFilters,"iytutut")
  // const [save, setSave] = useState(false);
  const {
    save,
    setSave,
    showMonthPicker,
    groupId,
    dealsView,
    setDealsView,
    switchValue,
    setSwitchValue,
  } = useContext(PeFilterContext);
  const { globalSearchResult } = useContext(TableDataContext);

  // const [showNotification, setShowNotification] = useState(false)
  /**
   * The function `savedList` toggles the value of the `save` variable.
   */
  const savedList = () => {
    setSave(!save);
  };
  const { pathname } = useLocation();
  const { isStudent, isDirectoryUser, isTrialExport } = useContext(UserContext);
  const [alertMsg, setalert] = useState({
    message: Constants.excelPopupMessage,
    show: true,
    icon: "",
  });

  // useEffect(()=>{},[isStudent])
  console.log(isDirectoryUser, "isStudent");
  useEffect(()=>{
    if (window.innerWidth < 800) {
        // setOpen(true);
        setIsMobile(true);
    }    },[])

  const isFromGlobalSearch = () =>
    refineSearchFilters[pathname]?.globalSearch?.length > 0 ? true : false;
  const onConfirmation = (flag) => {
    setalert({ show: false, message: "" });
  };

  const dealsViewHandler = (checked) => {
      setDealsView(checked);
  };

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const refinesearch = queryParams.get('refinesearch');
    if (refinesearch) {
      const filters = JSON.parse(decodeURIComponent(refinesearch));
      console.log('Refine Search Filters:', filters);
        const pathKey = location.pathname.split("/").slice(0, 3).join("/"); // Gets '/pe/companies'
        console.log('Path Key:', pathKey);
      
      setRefineSearchFilters(filters);
      console.log('Updated Refine Search Filters:', refineSearchFilters,refineSearchFilters[pathKey]);
    }
  }, [location.search]);

  return (
    <>
      <Layout menu="pe">
        <div className="flex min-h-screen h-screen flex-col">
          {/* Bottom section */}
          <div className="flex min-h-0 flex-1 overflow-hidden">
            {/* Narrow sidebar*/}
            {/* Main area */}
            <main className= {"min-w-0 flex-1 mt-12 border-t border-gray-200 flex"}>
              {/* Primary column */}
              <section className="flex h-full min-w-0 flex-1 flex-col lg:order-last bg-[#EDEDED]">
                {/* Your content */}
                <div className="mr-[5rem] flex justify-between lg:items-center xl:items-center  md:items-center items-baseline">
                  {/* <FilterTag /> */}
                  <div></div>
                  {}
                  <ToggleDealsViewButton/>
                </div>
                <div className="pl-3 pr-4 lg:pr-4 md:pr-5">
                  <div className="px-2  md:px-3 rounded-[6px] rounded-b-none bg-white block lg:flex flex-row justify-between">
                    {/* <MainMenu active={1} menu="pe" subMenu="investment" /> */}
                    <div></div>
                        <div
                          className={
                            "justify-between items-center px-2 py-2 space-x-4 " +
                            (showMonthPicker != 0 ? "md:flex" : "flex")
                          }
                        >
                          {isMobile && (
                            <>
                              {/* <button
                                className="cursor-pointer lg:ml-7 ml-4 mt-2"
                                onClick={() => setOpen(!open)}
                              >
                                <FaFilter color="#bc8b20" size={21} />
                              </button> */}
                                {/* {!open && <IoClose color="#bc8b20" size={25} className="fixed z-50 top-16 right-[39vw] mb-2" />} */}
                              <a>
                                <img
                                  className="h-[24px] max-w-[2px] mt-1 "
                                  src={line}
                                />
                              </a>
                            </>
                          )}
                          <div
                            className={
                              showMonthPicker != 0
                                ? "hidden md:flex space-x-3"
                                : "flex space-x-3"
                            }
                          >
                            {isStudent == "true" ? (
                              <></>
                            ) : (
                              <>
                                <button>
                                  {isTrialExport == "false" ? (
                                    <ExcelDownloader
                                      url={exportPDF}
                                      fileName={
                                        Constants.exportNames
                                          .pe_company_investment
                                      }
                                      data={{ type: "pe_vc_investment" }}
                                      children={
                                        <DownloadTrigger />
                                      }
                                    />
                                  ) : (
                                    <DownloadTrigger onClick={() => setShowPopup(!showPopup)} />
                                  )}
                                  {showPopup && (
                                    <ExportPopup
                                      modules="company"
                                      fileName={
                                        Constants.exportNames
                                          .pe_company_investment
                                      }
                                      url={exportPDF}
                                      module_type="pe"
                                      onClose={() => setShowPopup(false)}
                                      exportOptions={data}
                                      isExport={isTrialExport}
                                      type="pe_vc_investment"
                                    />
                                  )}
                                </button>
                              </>
                            )}
                          </div>
                        </div>
                  </div>
                </div>
                <div id="overFlow" className="overflow-y-auto">
                  <Table
                    menu="pe"
                    sub_type_master_id={
                      Constants.subCategoryIds.pe_investments_id
                    }
                  />
                </div>
              </section>
              {/* Secondary column (hidden on smaller screens) */}
              
            </main>
          </div>
        </div>
      </Layout>
    </>
  );
}

export default Home;
